module.exports = __webpack_public_path__ + "img/top_primebnr_pc.026c4c26.png";